import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Modal extends BaseOption {
  static userInterfaceComponent = {
    label: "Modal",
    component: inspectorTools.MODAL_PICKER,
  };

  static defaultValue = "";
}
